import { useEffect, useState } from 'react';
import { StepCard } from '../StepCard';
import { Button } from '../../../components/ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../../components/ui/select';
import { Input } from '../../../components/ui/input';
import axios from 'axios';
import { SelectGroup } from '../../../components/ui/selectDashboard';

// Hardcoded options from PreparationDetailsFormV2
const PREPARATION_MODES = [
  { value: 'Online Paid Course', label: 'Online Paid Course' },
  { value: 'Offline Paid Course', label: 'Offline Paid Course' },
  {
    value: 'Combination of both Online & Offline Paid Courses',
    label: 'Combination of both Online & Offline Paid Courses',
  },
  {
    value: 'Self Study using Free Resources. i.e. YouTube, MARKS app',
    label: 'Self Study using Free Resources. i.e. YouTube, MARKS app',
  },
];

const ONLINE_INSTITUTES = [
  { value: 'physics-wallah', label: 'Physics Wallah (PW)' },
  { value: 'unacademy', label: 'Unacademy' },
  { value: 'competishun', label: 'Competishun' },
  { value: 'IIT School', label: 'IIT School' },
  { value: 'esaral', label: 'eSaral' },
  { value: 'vedantu', label: 'Vedantu' },
  { value: "Aakash Byju's", label: "Aakash Byju's" },
  { value: 'other', label: 'Other' },
];

const OFFLINE_INSTITUTES = [
  { value: 'allen', label: 'Allen' },
  { value: 'FIITJEE', label: 'FIITJEE' },
  { value: 'CFAL', label: 'CFAL' },
  { value: "Aakash Byju's", label: "Aakash Byju's" },
  { value: 'Physics Walla Vidyapeeth', label: 'Physics Walla Vidyapeeth' },
  { value: 'Bakliwal Tutorials', label: 'Bakliwal Tutorials' },
  { value: 'Rahmani 30', label: 'Rahmani 30' },
  { value: 'Modi School', label: 'Modi School' },
  { value: 'Unacademy', label: 'Unacademy' },
  { value: 'Motion Academy', label: 'Motion Academy' },
  { value: 'VMC', label: 'VMC' },
  { value: 'other', label: 'Other' },
];

const FREE_RESOURCES = [
  { value: 'YouTube', label: 'YouTube' },
  { value: 'Khan Academy', label: 'Khan Academy' },
  { value: 'MARKS app', label: 'MARKS app' },
  { value: 'Self Study', label: 'Self Study' },
  { value: 'other', label: 'Other' },
];

export function LearningMode({ onNext, onPrevious, data, onDataChange }) {
  const [formData, setFormData] = useState({
    preparationMode: data?.preparationMode || '',
    onlineInstituteName: data?.onlineInstituteName || '',
    offlineInstituteName: data?.offlineInstituteName || '',
    onlineBatchName: data?.onlineBatchName || '',
    offlineBatchName: data?.offlineBatchName || '',
    freeOnlineBatch: data?.freeOnlineBatch || false,
    freeOnlineBatchName: data?.freeOnlineBatchName || '',
    customOnlineInstitute: data?.customOnlineInstitute || '',
    customOfflineInstitute: data?.customOfflineInstitute || '',
    customFreeResource: data?.customFreeResource || '',
  });
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    const userProfile = JSON.parse(localStorage.getItem('userProfile') || '{}');
    if (userProfile.learningModeDetails) {
      const prepDetails = userProfile.learningModeDetails;

      const isOnlineOther = !ONLINE_INSTITUTES.some((inst) => inst.value === prepDetails?.onlineInstituteName);
      const onlineInstitute = isOnlineOther ? 'other' : prepDetails?.onlineInstituteName || '';

      const isOfflineOther = !OFFLINE_INSTITUTES.some((inst) => inst.value === prepDetails?.offlineInstituteName);
      const offlineInstitute = isOfflineOther ? 'other' : prepDetails?.offlineInstituteName || '';

      const isFreeResourceOther = !FREE_RESOURCES.some((res) => res.value === prepDetails?.freeOnlineBatchName);
      const freeResourceName = isFreeResourceOther ? 'other' : prepDetails?.freeOnlineBatchName || '';

      setFormData((prev) => ({
        ...prev,
        preparationMode: prepDetails.preparationMode || '',
        onlineInstituteName: onlineInstitute,
        offlineInstituteName: offlineInstitute,
        onlineBatchName: prepDetails.onlineBatchName || '',
        offlineBatchName: prepDetails.offlineBatchName || '',
        freeOnlineBatch: prepDetails.freeOnlineBatch || false,
        freeOnlineBatchName: freeResourceName,
        customOnlineInstitute: isOnlineOther ? prepDetails.onlineInstituteName : '',
        customOfflineInstitute: isOfflineOther ? prepDetails.offlineInstituteName : '',
        customFreeResource: isFreeResourceOther ? prepDetails.freeOnlineBatchName : '',
      }));
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.preparationMode) {
      setErrors({ form: 'Please select your preparation mode' });
      return;
    }

    setIsLoading(true);
    try {
      const learningModeDetails = {
        preparationMode: formData.preparationMode,
        onlineInstituteName:
          formData.onlineInstituteName === 'other' ? formData.customOnlineInstitute : formData.onlineInstituteName,
        offlineInstituteName:
          formData.offlineInstituteName === 'other' ? formData.customOfflineInstitute : formData.offlineInstituteName,
        onlineBatchName: formData.onlineBatchName,
        offlineBatchName: formData.offlineBatchName,
        freeOnlineBatch: formData.freeOnlineBatch,
        freeOnlineBatchName:
          formData.freeOnlineBatchName === 'other' ? formData.customFreeResource : formData.freeOnlineBatchName,
        year: new Date().getFullYear(),
      };

      const updateData = {
        learningModeDetails: learningModeDetails,
      };

      const response = await axios.patch(`/api/user/profile/`, updateData);

      if (response.status === 200) {
        localStorage.setItem('userProfile', JSON.stringify(response.data.data.user));
        onDataChange(response.data.data.user);
        onNext(); // Continue to next step (HearAboutUs)
      }
    } catch (error) {
      console.error('Error updating profile:', error);
      setErrors({ submit: 'Failed to save data. Please try again.' });
    } finally {
      setIsLoading(false);
    }
  };

  const handleSelectChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    if (errors.form) {
      setErrors((prev) => ({ ...prev, form: '' }));
    }
  };

  const showOnlineInstitute =
    formData.preparationMode === 'Online Paid Course' ||
    formData.preparationMode === 'Combination of both Online & Offline Paid Courses';

  const showOfflineInstitute =
    formData.preparationMode === 'Offline Paid Course' ||
    formData.preparationMode === 'Combination of both Online & Offline Paid Courses';

  const showFreeResources = formData.preparationMode === 'Self Study using Free Resources. i.e. YouTube, MARKS app';

  return (
    <StepCard>
      <div className="flex flex-col h-full">
        <div className="space-y-6">
          <div>
            <h2 className="text-2xl sm:text-3xl font-bold text-[var(--q3-neutral-default)] mb-2">Learning Mode</h2>
            <p className="text-[var(--q3-neutral-light)] text-sm sm:text-base">
              Please add your preparation or coaching details.
            </p>
          </div>
        </div>

        <div className="flex-1 overflow-y-auto py-4">
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-4">
              <Select
                value={formData.preparationMode}
                onValueChange={(value) => handleSelectChange('preparationMode', value)}
              >
                <SelectTrigger className="border-[var(--q3-stroke-normal)] h-[40px] w-full rounded-full flex justify-between items-center px-4 focus:outline-none focus:ring-0">
                  {formData.preparationMode ? (
                    <div className="flex items-center gap-1 w-full min-w-0">
                      <span className="shrink-0 text-[var(--q3-neutral-light)]">Preparation Mode :</span>
                      <div className="flex-1 text-left truncate min-w-0 text-[var(--q3-neutral-default)]">
                        {(() => {
                          const selectedMode = PREPARATION_MODES.find(
                            (mode) => mode.value === formData.preparationMode,
                          );
                          const label = selectedMode?.label || '';
                          return label.length > 35 ? label.slice(0, 35) + '...' : label;
                        })()}
                      </div>
                    </div>
                  ) : (
                    <SelectValue placeholder="How are you preparing for your exams?" />
                  )}
                </SelectTrigger>
                <SelectContent className="rounded-xl bg-[var(--q3-surface-default)] shadow-lg w-(--radix-select-trigger-width) min-w-(--radix-select-trigger-width) pr-6">
                  <SelectGroup>
                    {PREPARATION_MODES.map((mode) => {
                      return (
                        <SelectItem
                          className="cursor-pointer rounded-3xl hover:bg-[var(--q3-surface-dimmer)]"
                          key={mode.value}
                          value={mode.value}
                        >
                          <div className="w-full">
                            <span className="text-sm leading-relaxed break-words">{mode.label}</span>
                          </div>
                        </SelectItem>
                      );
                    })}
                  </SelectGroup>
                </SelectContent>
              </Select>

              {showOnlineInstitute && (
                <>
                  <Select
                    value={formData.onlineInstituteName}
                    onValueChange={(value) => handleSelectChange('onlineInstituteName', value)}
                  >
                    <SelectTrigger className="border-[var(--q3-stroke-normal)] h-[40px] w-full rounded-full flex justify-between items-center px-4 focus:outline-none focus:ring-0">
                      {formData.onlineInstituteName ? (
                        <div className="flex items-center gap-1">
                          <span className="shrink-0 text-[var(--q3-neutral-light)] ">Online Institute :</span>
                          <SelectValue placeholder="Which online coaching are you enrolled in?" />
                        </div>
                      ) : (
                        <SelectValue placeholder="Which online coaching are you enrolled in?" />
                      )}
                    </SelectTrigger>
                    <SelectContent className="rounded-3xl">
                      {ONLINE_INSTITUTES.map((institute) => (
                        <SelectItem
                          className="cursor-pointer rounded-3xl hover:bg-[var(--q3-surface-dimmer)]"
                          key={institute.value}
                          value={institute.value}
                        >
                          <span className="text-[var(--q3-neutral-default)]">{institute.label}</span>
                        </SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                  {formData.onlineInstituteName === 'other' && (
                    <div className="relative h-[40px] w-full rounded-full border border-input bg-background px-4 py-2 text-sm file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50 flex items-center">
                      {formData.customOnlineInstitute && (
                        <span className="shrink-0 mr-1 text-[var(--q3-neutral-light)]">Institute Name :</span>
                      )}
                      <Input
                        type="text"
                        placeholder={formData.customOnlineInstitute ? '' : 'Enter online institute name'}
                        value={formData.customOnlineInstitute}
                        onChange={(e) => handleSelectChange('customOnlineInstitute', e.target.value)}
                        className="flex-1 h-full w-full bg-transparent border-none p-0 text-[var(--q3-neutral-default)] focus:outline-none focus:ring-0"
                      />
                    </div>
                  )}

                  <div className="relative h-[40px] w-full rounded-full border border-input bg-background px-4 py-2 text-sm disabled:cursor-not-allowed flex items-center">
                    {formData.onlineBatchName && (
                      <span className="shrink-0 mr-1  text-[var(--q3-neutral-light)] ">Batch Name :</span>
                    )}
                    <Input
                      type="text"
                      placeholder={
                        formData.onlineBatchName
                          ? ''
                          : "Enter the name of the online batch you're enrolled in (Optional)"
                      }
                      value={formData.onlineBatchName}
                      onChange={(e) => handleSelectChange('onlineBatchName', e.target.value)}
                      className="flex-1 h-full shadow-none w-full bg-transparent border-none p-0 focus:outline-none focus:ring-0"
                    />
                  </div>
                </>
              )}

              {showOfflineInstitute && (
                <>
                  <Select
                    value={formData.offlineInstituteName}
                    onValueChange={(value) => handleSelectChange('offlineInstituteName', value)}
                  >
                    <SelectTrigger className="border-[var(--q3-stroke-normal)] h-[40px] w-full rounded-full flex justify-between items-center px-4 focus:outline-none focus:ring-0 overflow-hidden">
                      {formData.offlineInstituteName ? (
                        <div className="flex items-center gap-1 min-w-0 flex-1">
                          <span className="shrink-0 text-[var(--q3-neutral-light)]">Offline Institute :</span>
                          <span className="truncate block max-w-full text-[var(--q3-neutral-default)]">
                            {OFFLINE_INSTITUTES.find((i) => i.value === formData.offlineInstituteName)?.label}
                          </span>
                        </div>
                      ) : (
                        <SelectValue placeholder="Which offline coaching are you enrolled in?" />
                      )}
                    </SelectTrigger>

                    <SelectContent className="rounded-3xl">
                      {OFFLINE_INSTITUTES.map((institute) => (
                        <SelectItem
                          className="cursor-pointer rounded-3xl hover:bg-[var(--q3-surface-dimmer)]"
                          key={institute.value}
                          value={institute.value}
                        >
                          <span className="text-[var(--q3-neutral-default)] truncate block max-w-full">
                            {institute.label}
                          </span>
                        </SelectItem>
                      ))}
                    </SelectContent>
                  </Select>

                  {formData.offlineInstituteName === 'other' && (
                    <div className="relative h-[40px] w-full rounded-full border border-input bg-background px-4 py-2 text-sm file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50 flex items-center">
                      {formData.customOfflineInstitute && (
                        <span className="shrink-0 mr-1 text-[var(--q3-neutral-light)]">Institute Name :</span>
                      )}
                      <Input
                        type="text"
                        placeholder={formData.customOfflineInstitute ? '' : 'Enter offline institute name'}
                        value={formData.customOfflineInstitute}
                        onChange={(e) => handleSelectChange('customOfflineInstitute', e.target.value)}
                        className="flex-1 h-full w-full bg-transparent border-none p-0 text-[var(--q3-neutral-default)] focus:outline-none focus:ring-0"
                      />
                    </div>
                  )}

                  <div className="relative h-[40px] w-full rounded-full border border-input bg-background px-4 py-2 text-sm disabled:cursor-not-allowed disabled:opacity-50 flex items-center">
                    {formData.offlineBatchName && (
                      <span className="shrink-0 mr-1  text-[var(--q3-neutral-light)] ">Batch Name :</span>
                    )}
                    <Input
                      type="text"
                      placeholder={
                        formData.offlineBatchName
                          ? ''
                          : "Enter the name of the offline batch you're enrolled in (Optional)"
                      }
                      value={formData.offlineBatchName}
                      onChange={(e) => handleSelectChange('offlineBatchName', e.target.value)}
                      className="flex-1 h-full w-full shadow-none bg-transparent border-none p-0 focus:outline-none focus:ring-0"
                    />
                  </div>
                </>
              )}

              {showFreeResources && (
                <>
                  {formData.freeOnlineBatch && (
                    <>
                      <Select
                        value={formData.freeOnlineBatchName}
                        onValueChange={(value) => handleSelectChange('freeOnlineBatchName', value)}
                      >
                        <SelectTrigger className="border-[var(--q3-stroke-normal)] h-[40px] w-full rounded-full flex justify-between items-center px-4 focus:outline-none focus:ring-0">
                          {formData.freeOnlineBatchName ? (
                            <div className="flex items-center gap-1">
                              <span className="shrink-0 text-[var(--q3-neutral-light)] ">Free Resource :</span>
                              <SelectValue placeholder="Select free resource" />
                            </div>
                          ) : (
                            <SelectValue placeholder="Select free resource" />
                          )}
                        </SelectTrigger>
                        <SelectContent className="rounded-3xl">
                          {FREE_RESOURCES.map((resource) => (
                            <SelectItem
                              className="rounded-3xl hover:bg-[var(--q3-surface-dimmer)]"
                              key={resource.value}
                              value={resource.value}
                            >
                              {resource.label}
                            </SelectItem>
                          ))}
                        </SelectContent>
                      </Select>

                      {formData.freeOnlineBatchName === 'other' && (
                        <div className="relative h-[40px] w-full rounded-full border border-input bg-background px-4 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-within:outline-none focus-within:ring-2 focus-within:ring-ring focus-within:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 flex items-center">
                          {formData.customFreeResource && (
                            <span className="shrink-0 mr-1  text-[var(--q3-neutral-light)] ">Resource Name :</span>
                          )}
                          <Input
                            type="text"
                            placeholder={
                              formData.customFreeResource ? '' : 'Enter the name(s) of the free online batch(es)'
                            }
                            value={formData.customFreeResource}
                            onChange={(e) => handleSelectChange('customFreeResource', e.target.value)}
                            className="flex-1 h-full w-full bg-transparent border-none p-0"
                          />
                        </div>
                      )}
                    </>
                  )}
                </>
              )}
            </div>

            {errors.form && <div className="text-[var(--q3-danger-normal)] text-sm text-center">{errors.form}</div>}
            {errors.submit && <div className="text-[var(--q3-danger-normal)] text-sm text-center">{errors.submit}</div>}
          </form>
        </div>

        <div className="flex flex-col sm:flex-row pt-4 gap-4 sm:gap-x-4">
          <Button
            type="button"
            variant="secondary"
            onClick={onPrevious}
            className="w-full sm:flex-shrink-0 sm:flex-grow-0 sm:basis-1/3 px-4 sm:px-8 rounded-full bg-[var(--q3-surface-default)] hover:bg-[var(--q3-surface-default)]/90 text-[var(--q3-neutral-default)] disabled:opacity-50 border border-[var(--q3-stroke-normal)]"
            disabled={isLoading}
          >
            Previous
          </Button>
          <Button
            type="submit"
            onClick={handleSubmit}
            className="w-full sm:flex-shrink-0 sm:flex-grow sm:basis-2/3 bg-[var(--q3-accent-normal)] hover:bg-[var(--q3-accent-normal)] text-[var(--q3-neutral-default_inverted)] disabled:opacity-50 px-4 sm:px-8 rounded-full"
            disabled={isLoading}
          >
            {isLoading ? 'Saving...' : 'Continue'}
          </Button>
        </div>
      </div>
    </StepCard>
  );
}
